export enum InternalSDKToAppMessageTypes {
  ON_READY = 'ON_READY',
  AUTH_TOKEN_SET = 'AUTH_TOKEN_SET',
  ON_NOTIFICATION_ACTION = 'ON_NOTIFICATION_ACTION',
  DISPLAY_PUSH_NOTIFICATION = 'DISPLAY_PUSH_NOTIFICATION',
  APP_STATE = 'APP_STATE',
  ON_EHR_EVENT = 'ON_EHR_EVENT',
}
